
<template>
    <ListDialog ref="SalesJournalDialog" :title="$parent.formatTitle('売上元帳')" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	      <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="SalesJournalReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【売上元帳】のデータを選択でき、初期値は×で消してから変更が可能です。" />
          <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
          <AtcCounterpart title="得意先" :value.sync="counterpart" :editor="editor" :needsCustomer="true" tooltip="ここで得意先を選択をすると、選択した得意先だけのデータを出力する事ができます。選択しない場合はすべての得意先のデータが出力できます。" />
          <AtcCategory title="取引先区分" :categoryGroup="categoryGroupCounterpart" :value.sync="counterpartCategory" tooltip="ここで取引先区分を選択をすると、選択した区分だけのデータを出力する事ができます。選択しない場合はすべての区分のデータが出力できます。" />
          <AtcCommodity title="商品" :editor="editor" :value.sync="commodity" tooltip="ここで商品を選択をすると、選択した商品だけのデータを出力する事ができます。選択しない場合はすべての商品のデータが出力できます。" />
	        <AtcCategory title="商品区分" :categoryGroup="categoryGroupCommodity" :value.sync="commodityCategory" tooltip="ここで商品区分を選択をすると、選択した区分だけのデータを出力する事ができます。選択しない場合はすべての区分のデータが出力できます。" />
        <Calendar title="出荷日(From)" :editor="editor" :value.sync="deliveryDateFrom"  :autoEntry="true" :dateFlag.sync="deliveryDateFromFlag" :deletable="true" tooltip="データを帳票に出力をする出荷日の開始日を指定します。ここで指定した日付以前のデータは出力対象外となります。" />
	      <Calendar title="出荷日(To)" :editor="editor" :value.sync="deliveryDateTo" :autoEntry="true" :dateFlag.sync="deliveryDateToFlag" :deletable="true" tooltip="データを帳票に出力をする出荷日の終了日を指定します。ここで指定した日付以降のデータは出力対象外となります。" />
	      <Calendar title="売上日(From)" :editor="editor" :value.sync="bookDateFrom"  :autoEntry="true" :dateFlag.sync="bookDateFromFlag" :deletable="false" :required="true" tooltip="データを帳票に出力をする売上日の開始日を指定します。ここで指定した日付以前のデータは出力対象外となります。" />
	      <Calendar title="売上日(To)" :editor="editor" :value.sync="bookDateTo"  :autoEntry="true" :dateFlag.sync="bookDateToFlag" :deletable="false" :required="true" tooltip="データを帳票に出力をする売上日の終了日を指定します。ここで指定した日付以降のデータは出力対象外となります。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>               
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>               
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptSalesJournal extends Vue {

  public reportTemplate: Common.ReportTemplate = null;
  public deliveryDateFrom: Date = null;
  public deliveryDateTo: Date = null;
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public counterpartCategory: Common.Category = null;
  public categoryGroupCounterpart: Common.CategoryGroup = Common.CategoryGroup.Counterpart;
  public commodity: Common.Commodity = null;
  public commodityCategory: Common.Category = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public onExcelExport :boolean = false;
  public deliveryDateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public deliveryDateToFlag : Common.dateFlags = Common.dateFlags.default;  
  public bookDateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public bookDateToFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){
      var query: Common.SalesJournalReportTemplateQuery = new Common.SalesJournalReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }

    this.bookDateFrom = new Date().getCalendarDate();
    this.bookDateFrom.setDate(1);
    this.bookDateTo = new Date().getCalendarDate();
    this.bookDateTo.setMonth(this.bookDateFrom.getMonth() + 1);
    this.bookDateTo.setDate(0);

    (this.$refs.SalesJournalDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SalesJournalReportQuery = new Common.SalesJournalReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.counterpartCategory = this.counterpartCategory;
    query.commodity = this.commodity;
    query.commodityCategory = this.commodityCategory;
    query.deliveryDateFrom = this.deliveryDateFrom;
    query.deliveryDateTo = this.deliveryDateTo;
    query.bookDateFrom = this.bookDateFrom;
    query.bookDateTo = this.bookDateTo;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
</script>
